import { Text } from '@bechtel/gds';
import { AlphabetListStyled, AlphabetStyled } from './styled';

const alphabets = Array.from(Array(26))
  .map((e, i) => i + 65)
  .map((x) => String.fromCharCode(x));

export const AlphabetList = ({ onSelect, selectedAlphabet }) => {
  return (
    <AlphabetListStyled>
      {alphabets.map((alphabet) => (
        <AlphabetStyled
          key={alphabet}
          onClick={() => {
            onSelect(alphabet);
          }}
        >
          <Text color={selectedAlphabet === alphabet ? 'blue.800' : 'grey.400'} size="300" weight="600">
            {alphabet}
          </Text>
        </AlphabetStyled>
      ))}
    </AlphabetListStyled>
  );
};
